// extracted by mini-css-extract-plugin
module.exports = {"sectionPrice":"Index_sectionPrice_13BVZ"};